export default __webpack_public_path__ + "static/spencer-68f1102e1d80bea35faa1a075263efcd.png";